import { render, staticRenderFns } from "./vsPaginationCustom.vue?vue&type=template&id=4208d6df"
import script from "./vsPaginationCustom.vue?vue&type=script&lang=js"
export * from "./vsPaginationCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\site-teste\\flash-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4208d6df')) {
      api.createRecord('4208d6df', component.options)
    } else {
      api.reload('4208d6df', component.options)
    }
    module.hot.accept("./vsPaginationCustom.vue?vue&type=template&id=4208d6df", function () {
      api.rerender('4208d6df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Resources/js/src/components/vsPaginationCustom/vsPaginationCustom.vue"
export default component.exports